// extracted by mini-css-extract-plugin
var _1 = "BZhJklZegIcIGKMyfRtQ";
var _2 = "qUmo_0B9BdzbRWC5fsQ5";
export { _1 as "figure", _2 as "image" }
